module.exports = __webpack_public_path__ + "static/media/handclp1.ce5193f6.wav";